<template>
    <div class="d-flex flex-column gap-2">
        <div class="d-flex gap-2">
            <i :class="['fi fi-lg fi-alert-circle align-self-start', typeClass]"
                style="align-self: center; font-size: 1.5rem;"></i>
            <h3>{{ alert?.title }}</h3>
        </div>
        <div class="subheading">
            {{ formatDate(alert?.created_at) }}
        </div>
        <!-- Default slot for flexible content -->
        <div class="notification-body" style="white-space: pre-line;" v-html="alert?.message"></div>
        <!-- Optional close and view buttons based on props -->
        <div class="d-flex gap-3 justify-content-end">
            <button v-if="this.alert.internal_link" @click="viewAction" class="btn btn-secondary">{{ viewButtonLabel }}</button>
            <IconButton preset="delete" @click="clearNotification" />
        </div>
    </div>
</template>

<script>
import IconButton from '@/components/IconButton.vue';
import { getNotificationViewButtonLabel } from '@/utils/notificationEventLabels.js';

export default {
    name: 'Notification',
    components: {
        IconButton,
    },
    props: {
        alert: {
            type: Object,
            required: true,
            validator(value) {
                // Ensure the alert object has the necessary structure
                return value && typeof value.title === 'string' && typeof value.type === 'string';
            }
        }
    },
    emits: ['clear', 'view'],
    computed: {
        typeClass() {
            return `type-${this.alert.type}`;
        },
        viewButtonLabel() {
            return getNotificationViewButtonLabel(this.alert?.event);
        },
    },
    methods: {
        clearNotification() {
            console.log(this.alert);
            this.$emit('clear', this.alert);
        },
        viewAction() {
            this.$emit('view', this.alert);
        },
        formatDate(isoString) {
            if (!isoString || isNaN(new Date(isoString).getTime())) {
                return 'Invalid date';
            }
            const date = new Date(isoString);
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            const options = { month: "short", day: "numeric", year: "numeric", timeZone: timeZone };
            const timeOptions = { hour: "numeric", minute: "2-digit", hour12: true, timeZone: timeZone };

            const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
            const formattedTime = new Intl.DateTimeFormat("en-US", timeOptions).format(date);

            return `${formattedDate} • ${formattedTime.toLowerCase()}`;
        }
        ,
    },
};
</script>

<style scoped>
.row {
    margin: 0 0 1rem 0;
    gap: var(--space-3);
}

h3 {
    margin: 0;
}

.subheading {
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 400;
    color: var(--neutral-800);
}

.notification-body {
    font-size: 1rem;
    font-weight: 400;
    line-height: 26px;
    color: var(--neutral-900);
    max-height: 100%;
    overflow-y: auto;
}

.type-INFO {
    color: var(--primary-500);
}

.type-WARNING {
    color: var(--warning);
}

.type-URGENT {
    color: var(--danger);
}
</style>
